import { Client } from "./client";
import { 
  RequirementProcedureTemplateAssignmentListResponse, 
  RequirementProcedureTemplateAssignmentResponse,
  CreateAssignmentRequest 
} from "@/backend/express/controllers/requirementProcedureTemplateAssignmentController";
import { FusaReply } from "@/types/replyTypes";
import { useGlobalStore } from "@/frontend/store/GlobalStore";
import { FusaToastType } from "@/frontend/toasts/types";
import { I18n } from "@/i18n/I18n";

export class RequirementProcedureTemplateAssignmentFrontendController {
  client: Client;

  constructor() {
    this.client = new Client();
  }

  getAssignmentsByRequirementId(requirementId: string): Promise<RequirementProcedureTemplateAssignmentListResponse> {
    return this.client.read(`/api/requirement-procedure-template-assignments/requirement/${requirementId}`);
  }

  getAllForProject(projectId: string): Promise<RequirementProcedureTemplateAssignmentListResponse> {
    return this.client.read(`/api/requirement-procedure-template-assignments/all-for-project/${projectId}`);
  }

  async createAssignment(data: CreateAssignmentRequest): Promise<RequirementProcedureTemplateAssignmentResponse> {
    const response = await this.client.create('/api/requirement-procedure-template-assignments', data);
    
    if (response.status === 201 && response.assignment) {
      useGlobalStore.getState().addToast({
        type: FusaToastType.SUCCESS,
        message: I18n.get('procedureTemplateAssigned'),
        header: I18n.get('success'),
        autohide: true
      });
    }
    
    return response;
  }

  async deleteAssignment(id: string): Promise<FusaReply> {
    const response = await this.client.delete(`/api/requirement-procedure-template-assignments/${id}`);
    
    if (response.status === 200) {
      useGlobalStore.getState().addToast({
        type: FusaToastType.SUCCESS,
        message: I18n.get('procedureTemplateUnassigned'),
        header: I18n.get('success'),
        autohide: true
      });
    }
    
    return response;
  }
}
